import Loader from 'components/Loader/Loader'
import React, { useEffect, useState } from 'react'
import { Button } from 'uikit/buttons/default'
import { fetchLoginUrl } from './utils'
import styles from './Login.module.scss'

const TERMS_AND_CONDITIONS_MESSAGE =
  'Accepting the Terms and Conditions is required to sign in. Please log in again and accept them to continue.'

const ERROR_MESSAGES: Record<string, string> = {
  access_denied: TERMS_AND_CONDITIONS_MESSAGE,
  consent_required: TERMS_AND_CONDITIONS_MESSAGE,
}

const DEFAULT_ERROR_MESSAGE =
  "We couldn't complete your sign-in. This can happen if a required step — such as accepting the Terms and Conditions — wasn't completed. Please try logging in again."

const getAuthErrorFromUrl = (): string | null =>
  new URLSearchParams(window.location.search).get('error')

const redirectToProvider = () => {
  fetchLoginUrl
    .then(res => {
      window.location.href = res.data.url
    })
    .catch(err => {
      console.error('err', err)
    })
}

const LoginPage = () => {
  const [authError] = useState<string | null>(getAuthErrorFromUrl)

  useEffect(() => {
    if (!authError) {
      redirectToProvider()
    }
  }, [authError])

  if (!authError) {
    return <Loader type='globalLoading' message={''} />
  }

  const message = ERROR_MESSAGES[authError] || DEFAULT_ERROR_MESSAGE

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <header>Log In to IVIX</header>
        <div className={styles.message}>{message}</div>
        <footer>
          <Button type='primary' onClick={redirectToProvider}>
            Back to Login
          </Button>
        </footer>
      </div>
    </div>
  )
}

export default LoginPage
